"use strict";

var storeService = angular.module('service.Store', []);

storeService.factory('storeService', ['$http', 'halClient', 'appSettings', 'localStorageService', 'storageKeys','$log',
    function($http, halClient, appSettings, localStorageService, storageKeys, $log){

        var storeAuthenticateUrl = appSettings.apiBaseUri + "/store/authenticate";
        var storeByStoreNumberUrl = appSettings.apiBaseUri + "/store/query-by-macDonaldsId";
        var storeById = appSettings.apiBaseUri + "/store/";
        var listByServiceProviderUrl = appSettings.apiBaseUri + "/store/query-by-servicerProviderId?servicerProviderId=";
        var storeTimeUrl = appSettings.apiBaseUri + "/store/time/";
        var engineerAuthenticateUrl = appSettings.apiBaseUri + "/store/authenticateEngineer?storeId=";

        function getStore(storeId) {
            if (localStorageService.get(storageKeys.storeKey)) {
                $log.debug("StoreService: Getting store, store present in local storage")
                return localStorageService.get(storageKeys.storeKey);
            } else if (storeId) {
                $log.debug("StoreService: Getting store, store not present in local storage, getting from the server")
                halClient.$get(storeById + storeId).then(function (store) {
                    return store;
                });
            }
        }

        return {
            authenticate: function (credentials){
                $log.debug("StoreService: Authenticating store")
                return halClient.$get(storeAuthenticateUrl + "?macDonaldsId=" + credentials.macDonaldsId + "&password=" + credentials.password);
            },

            authenticateImpersonatedUser: function (credentials){
                $log.debug("StoreService: Authenticating store for Impersonation")
                return halClient.$get(storeAuthenticateUrl + "?macDonaldsId=" + credentials.macDonaldsId + "&password=" + credentials.password + "&isImpersonated=true");
            },

            // Revisit this after to see if getStore by storeId is needed
            getStore: getStore,
            setStore: function(storeId){
                $log.debug("StoreService: Setting store")
                halClient.$get(storeById + storeId).then(function(store){
                    localStorageService.set(storageKeys.storeKey, store);
                }).catch(function (error) {
                    $log.error("StoreService: Error while setting store", error)
                });
            },

            requestStoreAuthentication: function(storeId){
                $log.debug("StoreService: Requesting  store authentication")
                return halClient.$get(engineerAuthenticateUrl + storeId);
            },

            setStoreContext: function(store){
                $log.debug("StoreService: Setting store context", store)
                localStorageService.set(storageKeys.storeKey, store);
                localStorageService.set(storageKeys.storeContextKey, store.storeAuthentication);
            },


            listByServiceProvider: function(){
                $log.debug("StoreService: Getting list by service provider")
                var profile = localStorageService.get(storageKeys.profileKey);
                return halClient.$get(listByServiceProviderUrl + profile.serviceProvider);
            },


            // Assumes that the date entered was in the store's local time zone and converts it to the ISO string
            // representation, which can safely be passed back to the server.
            dateAsStoreTimeZone: function(t) {
                return new timezoneJS.Date(1900 + t.getYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(),
                    this.getStore().timeZone).toJSON();
            },

            isStoreMode: function(){
                return localStorageService.get(storageKeys.loginTypeKey) === appSettings.storeLoginType;
            },

            removeStoreContext: function(){
                $log.debug("StoreService: Removing store context from local storage")
                localStorageService.remove(storageKeys.storeKey);
                localStorageService.remove(storageKeys.storeContextKey);
                delete $http.defaults.headers.common['X-Context-Store']
            },

            removeLoginType: function () {
                $log.debug("StoreService: Removing login type key from local storage")
                localStorageService.get(storageKeys.loginTypeKey);
            }
        }
    }]);